import actions from '../../actionTypes';

export default (zoneId, locations) => {
  return {
    type: actions.SET_LOCATIONS,
    zoneId,
    locations
  };
};



// WEBPACK FOOTER //
// ./src/reducers/locations/actions/setLocations.js